import { nl } from "./nl";
import type { Language, Strings } from "./types";

export type { Interval, Language, Strings } from "./types";

// Alle UI-teksten staan in een taaltabel per taal; voorlopig is er alleen Nederlands.
export const LANGUAGE: Language = "nl";

export const STRINGS: Strings = nl;
